import { DropDownDto } from '../../../../core/dto/dropdown/dropdowndto';
import * as React from 'react';
import { DropDownRowComponent } from './dropdownrowcomponent';
import { DropDownListViewModelImpl } from '../dropdownlistviewmodel';
import { BaseContext } from '../../../../utils/basecontext';
import { DropDownRowCSSStyleImpl } from './dropdownrowcss';

export interface DropdownRowViewModelHandler
{
    onRowSelected(dropDownDto: DropDownDto): void;
}

export class DropDownRowViewModelImpl extends DropDownListViewModelImpl<DropDownDto>
{
    constructor(private isImageRequired: boolean, context: BaseContext,protected dropdownRowViewModelHandler: DropdownRowViewModelHandler)
    {
        super(context);
    }
    
    getView(t: DropDownDto, position: number): boolean | JSX.Element 
    {
        console.log("-----position: " + position + ",size: " + this.getListOfDatas().length);

        return <DropDownRowComponent isImageRequired={this.isImageRequired} cssStyle={new DropDownRowCSSStyleImpl(this.getContext())} isLastIndex={(position + 1) === this.getListOfDatas().length} onRowSelected={(id) => this.dropdownRowViewModelHandler.onRowSelected(id)} key={position}  context={this.getContext()} dropDownDto={t}  position={position}/>;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownrow/dropdownviewmodel.tsx